import { render, staticRenderFns } from "./local-dana.vue?vue&type=template&id=4b894ee5"
import script from "./local-dana.vue?vue&type=script&lang=js"
export * from "./local-dana.vue?vue&type=script&lang=js"
import style0 from "./local-dana.vue?vue&type=style&index=0&id=4b894ee5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports